import axios from 'axios'
import { useState } from 'react'
import { useEffect } from 'react'
import { IMPERSONATE_ENDPOINT } from '../../hooks/constants'
import { IMPERSONATE_PAGE } from '../../hooks/constants'
import { apiHost } from '../../config'

interface FormData {
  accountNumber: string
  landingPage: string
}

const initialFormData = () => ({
  accountNumber: '',
  landingPage: ''
})


const SwitchUserContent = () => {
  const [formData, setFormData] = useState<FormData>(initialFormData)
  const [error, setError] = useState('')
  useEffect(() => {
  const params = new URLSearchParams(window.location.search)
  const errorType = params.get('error')

    if (errorType === 'impersonationFailed') {
      setError('Technical Error while switching user/account. Please reach out to IT Team')
    } else if (errorType === 'impersonationAcctInvalid'){
      //this is returned for errors returned from backend
      setError('Error while switching user/account. Please check your input and try again')
    }
  }, [])

  const handleInputChange = (event: any) => {
    const { name, value } = event.target
    let formattedValue = value

    setFormData((prev) => {
      const updatedFormData = { ...prev, [name]: formattedValue }
      return updatedFormData
    })
  }

  const callImpersonateApi = async () => {
    const requestParams = {
      accountNumber: formData.accountNumber,
      landingPage: formData.landingPage,
      _csrf: window?.RequestJson?.page?.reserved?.csrfToken
    }

    const host = window.location.origin === undefined ? apiHost : window.location.origin
    const params = new URLSearchParams(requestParams).toString()
    try {
      const response = await axios({
        url: `${host}/` + IMPERSONATE_ENDPOINT,
        maxRedirects: 0,
        method: 'POST',
        headers: {
          Accept:
            'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7',
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-TOKEN': window?.RequestJson?.page?.reserved?.csrfToken
        },

        data: params,
        validateStatus: (status) => status >= 200 && status < 400 // <- allow 3xx responses
      })

      //console.log('Headers :' + JSON.stringify(response.headers))
      //console.log('Response:' + JSON.stringify(response))
      console.log('response of page  '+ response.request.responseURL)
      const redirectLocation = response.request.responseURL
      if (redirectLocation === undefined) {
        window.location.href = `${host}/` + IMPERSONATE_PAGE
      } else {
        window.location.href = redirectLocation
      }
    } catch (error) {
      //exceptions while loading landingPage
      console.error('Error while calling impersonation', error)
      if (axios.isAxiosError(error)) {
         const status = error.response?.status
         if(status === 403){
          window.location.href = error.response?.request.responseURL
          return
         }
      }
      window.location.href = `${host}/` + IMPERSONATE_PAGE + '?error=impersonationFailed'
    }
  }

  const renderSwitchUserContent = () => {
    return (
      <>
        <div className='row'>
          <div className='col text-center page-header'>
            <h3>Switch/Impersonate a residential user using below form</h3>
          </div>
        </div>
        {error && (
          <div className="alert alert-danger pl-1 pr-2 ml-alert-err">
            <div className="alert-content error ml-1">
              <span>{error}</span>
            </div>
          </div>
        )}
        <div className='hrd-two-up-header'>
          <div
            className='col-md-12'
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start'
            }}
          >
            <label className='col-form-label'>
              Account Number 13<span className='required-asterisk'>*</span>
            </label>
            <input
              type='text'
              id='accountNumber'
              name='accountNumber'
              value={formData.accountNumber}
              onChange={handleInputChange}
              size={20}
              maxLength={50}
              aria-label='accountNumber'
              aria-required='true'
              data-automation-id='accountNumbertxt'
            />

            <label className='col-form-label'>
              Landing Page<span className='required-asterisk'>*</span>
            </label>
            <input
              type='text'
              id='landingPage'
              name='landingPage'
              value={formData.landingPage}
              onChange={handleInputChange}
              size={20}
              maxLength={50}
              aria-label='landingPage'
              aria-required='true'
              data-automation-id='landingPagetxt'
            />
            <input
              style={{ marginTop: '20px', background: '#285A93', color: '#fff' }}
              type='button'
              id='submit'
              value='Switch User'
              onClick={callImpersonateApi}
              aria-label='Switch User'
              data-automation-id='submitbtn'
            />
          </div>
        </div>
      </>
    )
  }

  return (
    <div
      style={{
        display: 'flex',
        flexBasis: '1 1 100%',
        flexDirection: 'column',
        gap: '2rem',
        justifyContent: 'center'
      }}
    >
      {renderSwitchUserContent()}
    </div>
  )
}

export default SwitchUserContent
